import React from 'react';
import AnalizeClienti from './Analize';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';


export default class SegmentareClientiInFunctieDeCaracteristici extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listSegmentare: null
        }
    }

    componentDidMount() {
        this.getDateSegmentare()
    }

    getDateSegmentare = async () => {
        let a = new AnalizeClienti()

        let seg = await a.segmentareAdministratori()

        // console.warn('seg :', seg);

        this.setState({
            listSegmentare: seg
        })
    }
    render() {
        return (

            <div>
                {this.state.listSegmentare &&
                    <div>
                        <h1 className='pm-title'>{this.dictionary.financiarContabil.segmentareClientiInFunctieDeCaracteristici}</h1>

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.educatie}</h2>

                        {this.state.listSegmentare.educatie.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.educatie}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                    </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                    </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.clasaSociala}</h2>

                        {this.state.listSegmentare.clasaSociala.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.clasa}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                         </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                        </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.limba}</h2>

                        {this.state.listSegmentare.limba.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.limba}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                        </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                         </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.nationalitate}</h2>

                        {this.state.listSegmentare.nationalitate.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.nationalitate}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                                 </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}
                        <h2 className='pm-title'>{this.dictionary.financiarContabil.numarMembriiFamilie}</h2>

                        {this.state.listSegmentare.nrMembriiFamilie.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.nrMembrii} MEMBRII FAMILIE</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                                     </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.ocupatie}</h2>

                        {this.state.listSegmentare.ocupatie.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.ocupatie}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.rasa}</h2>

                        {this.state.listSegmentare.rasa.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.rasa}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                                 </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}


                        <h2 className='pm-title'>{this.dictionary.financiarContabil.religie}</h2>

                        {this.state.listSegmentare.religie.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.religie}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                                    </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.sex}</h2>

                        {this.state.listSegmentare.sexe.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.sex === 'M' ? this.dictionary.financiarContabil.masculin : this.dictionary.financiarContabil.feminin}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                {this.dictionary.financiarContabil.ocupatia}
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.stilDeViata}</h2>

                        {this.state.listSegmentare.stilDeViata.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.stil}</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                    {this.dictionary.financiarContabil.ocupatia}
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}

                        <h2 className='pm-title'>{this.dictionary.financiarContabil.venit}</h2>

                        {this.state.listSegmentare.venit.map((e, idx) => {

                            return (
                                <div key={idx} className='container'>
                                    <h4 className='pm-title'>{e.venit} LEI</h4>
                                    <Table className='pm-indicatori-table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    {this.dictionary.financiarContabil.nume}
                                                </TableCell>
                                                <TableCell>
                                                    {this.dictionary.financiarContabil.ocupatia}
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>


                                        <TableBody >

                                            {e.clienti.map((c, idx2) => {

                                                return (
                                                    <TableRow  key={'r'+idx2}>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.nume}
                                                        </TableCell>
                                                        <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                            {c.ocupatie}
                                                        </TableCell>

                                                    </TableRow>
                                                )


                                            })}


                                        </TableBody>


                                    </Table>

                                </div>
                            )

                        })}



                    </div>
                }
            </div>
        );
    }
}